import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import BlogArticle from "./index";
import { getPage, getPages } from "../../Utility/nevtanPagesApi";

// Route wrapper for /blog/:slug — fetches one article by slug plus the full
// list (for the sidebar/related), client-side. Guards every failure so a bad
// slug or API error renders a fallback, never a white screen.
const BlogArticlePage = () => {
  const { slug } = useParams();
  const { i18n } = useTranslation();
  const [page, setPage] = useState(null);
  const [pages, setPages] = useState([]);
  const [status, setStatus] = useState("loading"); // loading | ready | notfound

  useEffect(() => {
    let active = true;
    setStatus("loading");
    setPage(null);
    (async () => {
      try {
        const result = await getPage(slug);
        if (!active) return;
        if (result?.success && result?.data) {
          setPage(result.data);
          setStatus("ready");
          try {
            const list = await getPages(i18n.language);
            if (active && list?.success && Array.isArray(list.data)) {
              setPages(list.data);
            }
          } catch (e) {
            // sidebar simply renders with no post data
          }
        } else {
          setStatus("notfound");
        }
      } catch (e) {
        if (active) setStatus("notfound");
      }
    })();
    return () => {
      active = false;
    };
  }, [slug, i18n.language]);

  if (status === "loading") {
    return (
      <main className="ss-blog" style={{ marginTop: 70, padding: 24, color: "rgba(255,255,255,0.6)" }}>
        Loading…
      </main>
    );
  }

  if (status === "notfound" || !page) {
    return (
      <main className="ss-blog" style={{ marginTop: 70, padding: 24, color: "rgba(255,255,255,0.6)" }}>
        Article not found.
      </main>
    );
  }

  return <BlogArticle page={page} slug={slug} pages={pages} />;
};

export default BlogArticlePage;
